module.exports = __webpack_public_path__ + "static/media/forasken2.941a3959.gif";